import axios from 'axios';
import { change } from 'redux-form';
import { toFromDates, convertUtcDate } from '../components/Common/cleanDates';
import {
  REQUEST_REGISTERS,
  FETCH_REGISTERS_SUCCESS,
  FETCH_REGISTERS_FAILRE,
  REQUEST_REGISTER_SESSIONS,
  REQUEST_REGISTER_SESSIONS_DATE,
  FETCH_REGISTER_SESSIONS_SUCCESS,
  FETCH_REGISTER_SESSIONS_FAILURE,
  VERIFY_REGISTER,

  REQUEST_POS_ORDERS,
  FETCH_POS_ORDERS_SUCCESS,
  FETCH_POS_ORDERS_FAILURE,

  REQUEST_POS_ORDER_DETAIL,
  FETCH_POS_ORDER_DETAIL_SUCCESS,
  FETCH_POS_ORDER_DETAIL_FAILURE,

  REQUEST_POS_CREDITS,
  FETCH_POS_CREDITS_SUCCESS,
  FETCH_POS_CREDITS_FAILURE,

  REQUEST_POS_CREDIT_DETAIL,
  FETCH_POS_CREDIT_DETAIL_SUCCESS,
  FETCH_POS_CREDIT_DETAIL_FAILURE,

  REQUEST_VOID_POS_ORDER,
  VOID_POS_ORDER_SUCCESS,
  VOID_POS_ORDER_FAILURE,

  REQUEST_EDIT_POS_PAYMENT,
  EDIT_POS_PAYMENT_SUCCESS,
  EDIT_POS_PAYMENT_FAILURE,
  FETCH_POS_HOLDS_SUCCESS,
  FETCH_POS_HOLDS_DETAILS_SUCCESS,
  
  REQUEST_POS_HOLDS_PDF,
  FETCH_POS_HOLDS_PDF_SUCCESS,
} from './type';

import {
  REGISTER_URL,
  VERIFY_URL,
  SESSION_URL,
  POS_ORDERS_URL,
  POS_CREDITS_URL,
  POS_CREDIT_URL,
  POS_HOLDS_URL,
  POS_HOLDS_VOID,
  POS_HOLDS_PRINT,
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';

function fetchPosHoldsOrderDetailSuccess(data) {
  return {
    type: FETCH_POS_HOLDS_DETAILS_SUCCESS,
    payload: data,
  };
}

export function fetchPosHoldsOrdersDetail(id) {
  return (dispatch) => {
    axios.get(
      `${POS_HOLDS_URL}${id}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((res) => {
        dispatch(fetchPosHoldsOrderDetailSuccess(res.data));
      })
      .catch((err) => {
        console.log('err', err);
      });
  };
}

function fetchposHoldsSuccess(data) {
  return {
    type: FETCH_POS_HOLDS_SUCCESS,
    payload: data,
  }
}

export function fetchPosHoldsOrders({ status, FromDate, ToDate, days }) {
  return (dispatch) => {
    dispatch(fetchposHoldsSuccess([]));
    const dates = toFromDates(days, FromDate, ToDate);
    axios.get(
      `${POS_HOLDS_URL}?Date__gte=${dates.fromDate}&Date__lte=${dates.toDate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      },
    )
      .then((res) => {
        dispatch(fetchposHoldsSuccess(res.data));
      })
      .catch((err) => {
        console.log('err fetching post holds orders',err);
      });
  };
}

export const voidSelectedPosHoldsOrder = (id, callback) => (dispatch) => {
  axios.delete(
    `${POS_HOLDS_VOID}${id}/`,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    },
  )
    .then((res) => {
      callback();
    })
    .catch((err) => {
      alert('err deleting pos holds with id', id);
    });
};

export function printPosHolds(id) {
  return (dispatch) => {
    dispatch({ type: REQUEST_POS_HOLDS_PDF });
    return axios.get(
      POS_HOLDS_PRINT + id,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        responseType: 'blob',
      },
    )
      .then((response) => {
        dispatch({
          type: FETCH_POS_HOLDS_PDF_SUCCESS,
          payload: response,
        });
      }, (err) => {
        console.log('ERROR IN response', err);
      });
  };
}

export function setField(fieldName, value) {
  return (dispatch) => {
    dispatch(change('posReport', fieldName, value));
  };
}

export function fetchRegisters(FromDate, ToDate) {
  const dates = toFromDates(-1, FromDate, ToDate);
  return dispatch => {
    dispatch({ type: REQUEST_REGISTERS });
    return axios.get(`${REGISTER_URL}?CashInTime__gte=${dates.fromDate}&CashInTime__lte=${dates.toDate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      }
    )
      .then(response => {
        dispatch(fetchRegistersSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchRegistersFailure(err));
      });
  };
}

export function fetchRegistersSuccess(registers) {
  return {
    type: FETCH_REGISTERS_SUCCESS,
    payload: registers
  };
}

export function fetchRegistersFailure(error) {
  return {
    type: FETCH_REGISTERS_FAILRE,
    payload: error
  };
}

export function fetchAllRegisterSessions(fromDate, toDate) {
  return dispatch => {
    dispatch({ type: REQUEST_REGISTER_SESSIONS });
    const dates = toFromDates(-1, fromDate, toDate);
    return axios.get(`${SESSION_URL}?CashInTime__gte=${dates.fromDate}&CashInTime__lte=${dates.toDate}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      }
    )
      .then(response => {
        dispatch(fetchRegisterSessionsSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchRegisterSessionsFailure(err));
      });
  };
}

export function fetchRegisterSessions(registerID) {
  return dispatch => {
    dispatch({ type: REQUEST_REGISTER_SESSIONS });
    let date = new Date();
    let formattedDate = date.getFullYear() + '-';
    formattedDate += date.getMonth()+1 + '-';
    if (date.getDate() < 10) {
      formattedDate += '0' + date.getDate();
    } else {
      formattedDate += date.getDate();
    }
    const dates = toFromDates(-1, formattedDate, formattedDate);
    return axios.get(REGISTER_URL + registerID + '?CashInTime__gte=' + dates.fromDate + '&CashInTime__lte=' + dates.toDate,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      }
    )
      .then(response => {
        dispatch(fetchRegisterSessionsSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchRegisterSessionsFailure(err));
      });
  };
}

export function fetchRegisterSessionsByDate(registerID, fromDate, toDate) {
  return dispatch => {
    dispatch({ type: REQUEST_REGISTER_SESSIONS_DATE });
    const dates = toFromDates(-1, fromDate, toDate);
    return axios.get(REGISTER_URL + registerID + '?CashInTime__gte=' + dates.fromDate + '&CashInTime__lte=' + dates.toDate,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      }
    )
      .then(response => {
        dispatch(fetchRegisterSessionsSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchRegisterSessionsFailure(err));
      });
  };
}


export function fetchRegisterSessionsSuccess(sessions) {
  return {
    type: FETCH_REGISTER_SESSIONS_SUCCESS,
    payload: sessions
  };
}

export function fetchRegisterSessionsFailure(error) {
  return {
    type: FETCH_REGISTER_SESSIONS_FAILURE,
    payload: error
  };
}

export function verifyRegisters(session_id, fields) {
  return dispatch => {
    dispatch({ type: VERIFY_REGISTER });
    const {
      CountedCash,
      CountedStoreCredit,
      CountedCard,
      CountedCheck,
      TotalCounted,
      Balance,
      NumCardTransaction,
      NumCheck,
    } = fields;
    return axios.post(VERIFY_URL + session_id + '/verify',
      {
          CountedCash,
          CountedStoreCredit,
          CountedCard,
          CountedCheck,
          TotalCounted,
          Balance,
          NumCardTransaction,
          NumCheck,
      },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      }
    )
      .then(response => {
        dispatch(fetchRegisterSessionsSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchRegisterSessionsFailure(err));
      });
  };
}

export function fetchPosOrders() {
  return dispatch => {
    dispatch(requestPosOrders());
    return axios.get(POS_ORDERS_URL,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
      .then(response => {
        dispatch(fetchPosOrdersSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPosOrdersFailure(err));
      });
  };
}

export function requestPosOrders() {
  return {
    type: REQUEST_POS_ORDERS,
  };
}

export function fetchPosOrdersSuccess(salesOrders) {
  return {
    type: FETCH_POS_ORDERS_SUCCESS,
    payload: salesOrders
  };
}

export function fetchPosOrdersFailure(error) {
  return {
    type: FETCH_POS_ORDERS_FAILURE,
    payload: error
  };
}

export function fetchPosOrdersByDate(postingDateGT, postingDateLT, days) {
  const dates = toFromDates(days, postingDateGT, postingDateLT)
  return dispatch => {
    dispatch(requestPosOrders());
    return axios.get(POS_ORDERS_URL + "search/?OrderDate__gte=" + dates.fromDate
    + "&OrderDate__lte=" + dates.toDate,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
      .then(response => {
        dispatch(fetchPosOrdersSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPosOrdersFailure(err));
      });
  }
}

export function fetchPosOrderDetail(Order_id) {
  return dispatch => {
    dispatch(requestPosOrderDetail());
    return axios.get(POS_ORDERS_URL + Order_id + '/',
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
      .then(response => {
        dispatch(fetchPosOrderDetailSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPosOrderDetailFailure(err));
      });
  }
}

export function requestPosOrderDetail() {
  return {
    type: REQUEST_POS_ORDER_DETAIL,
  };
}

export function fetchPosOrderDetailSuccess(salesOrderDetail) {
  salesOrderDetail = salesOrderDetail.data;
  // The date data fetched is in the form of string, which needs to be modified into Date type
  if (salesOrderDetail.OrderDate) salesOrderDetail.OrderDate = convertUtcDate(salesOrderDetail.OrderDate);
  if (salesOrderDetail.ETADate) salesOrderDetail.ETADate = convertUtcDate(salesOrderDetail.ETADate);
  if (salesOrderDetail.ReceivedDate) salesOrderDetail.ReceivedDate = convertUtcDate(salesOrderDetail.ReceivedDate);
  if (salesOrderDetail.DispatchDate) salesOrderDetail.DispatchDate = convertUtcDate(salesOrderDetail.DispatchDate);
  return {
    type: FETCH_POS_ORDER_DETAIL_SUCCESS,
    payload: salesOrderDetail
  };
}

export function fetchPosOrderDetailFailure(error) {
  return {
    type: FETCH_POS_ORDER_DETAIL_FAILURE,
    payload: error
  };
}

export function fetchPosOrdersByFilter(postingDateGT, postingDateLT, days, status, customer, type) {
  const SaleStatus = (status && status !== 'all') ?  `&SaleStatus=${status}` : '';
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  if (customer) {
    customer = `&Customer__Customer_id=${customer}`;
  } else {
    customer = '';
  }
  if (!type) {type = ''}

  return dispatch => {
    dispatch(requestPosOrders());
    return axios.get(
      POS_ORDERS_URL + "?Date__gte=" + dates.fromDate + "&Date__lte=" + dates.toDate + SaleStatus + customer + type,
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
      .then(response => {
        dispatch(fetchPosOrdersSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPosOrdersFailure(err));
      });
  }
}

export function voidPosOrder(Order_id) {
  return dispatch => {
    dispatch({ type: REQUEST_VOID_POS_ORDER });
    axios.delete(POS_ORDERS_URL + Order_id + '/',
      {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
      }
    )
      .then(response => {
        dispatch(voidPosOrderSuccess());
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(voidPosOrderFailure(err));
      });
  }
}

export function voidPosOrderSuccess() {
  return {
    type: VOID_POS_ORDER_SUCCESS,
  }
}

export function voidPosOrderFailure(err) {
  return {
    type: VOID_POS_ORDER_FAILURE,
    payload: err,
  }
}

function editPosPaymentSuccess(response) {
  return dispatch => new Promise((resolve) => {
    dispatch({
      type: EDIT_POS_PAYMENT_SUCCESS,
      payload: response,
    });
    resolve();
  });
}

function editPosPaymentFailure(error) {
  return {
    type: EDIT_POS_PAYMENT_FAILURE,
    payload: error,
  };
}

export function editPosPayment(posOrderID, data) {
  return (dispatch) => {
    dispatch({ type: REQUEST_EDIT_POS_PAYMENT });
    axios({
      method: 'put',
      data,
      url: `${POS_ORDERS_URL}${posOrderID}/`,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then((response) => {
      dispatch(editPosPaymentSuccess(response))
        .then(() => {
          dispatch(fetchPosOrderDetail(posOrderID));
        });
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      dispatch(editPosPaymentFailure(err));
    });
  };
}

// POS Credit action
export function requestPosCredits() {
  return {
    type: REQUEST_POS_CREDITS,
  };
}

export function fetchPosCreditsSuccess(salesOrders) {
  return {
    type: FETCH_POS_CREDITS_SUCCESS,
    payload: salesOrders,
  };
}

export function fetchPosCreditsFailure(error) {
  return {
    type: FETCH_POS_CREDITS_FAILURE,
    payload: error,
  };
}

export function fetchPosCredits() {
  const token = localStorage.getItem('token');
  return (dispatch) => {
    dispatch(requestPosCredits());
    return axios.get(
      POS_CREDITS_URL,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    )
      .then((response) => {
        dispatch(fetchPosCreditsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPosCreditsFailure(err));
      });
  };
}

export function fetchPosCreditsByDate(postingDateGT, postingDateLT, days) {
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  const token = localStorage.getItem('token');
  return (dispatch) => {
    dispatch(requestPosOrders());
    return axios.get(
      `${POS_CREDITS_URL}?Date__gte=${dates.fromDate}&Date__lte=${dates.toDate}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    )
      .then((response) => {
        dispatch(fetchPosOrdersSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPosOrdersFailure(err));
      });
  };
}

export function fetchPosCreditsByFilter(postingDateGT, postingDateLT, days, status) {
  const SaleStatus = (status && status !== 'all') ? `&SaleStatus__in=${status}` : '';
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  const token = localStorage.getItem('token');
  return (dispatch) => {
    dispatch(requestPosCredits());
    return axios.get(
      `${POS_CREDITS_URL}?Date__gte=${dates.fromDate}&Date__lte=${dates.toDate}${SaleStatus}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    )
      .then((response) => {
        dispatch(fetchPosCreditsSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPosCreditsFailure(err));
      });
  };
}

export function requestPosCreditDetail() {
  return {
    type: REQUEST_POS_CREDIT_DETAIL,
  };
}

export function fetchPosCreditDetailSuccess(salesCreditDetail) {
  salesCreditDetail = salesCreditDetail.data;
  // The date data fetched is in the form of string, which needs to be modified into Date type
  if (salesCreditDetail.CreateDatetime) salesCreditDetail.CreateDatetime = convertUtcDate(salesCreditDetail.CreateDatetime);
  return {
    type: FETCH_POS_CREDIT_DETAIL_SUCCESS,
    payload: salesCreditDetail,
  };
}

export function fetchPosCreditDetailFailure(error) {
  return {
    type: FETCH_POS_CREDIT_DETAIL_FAILURE,
    payload: error,
  };
}

export function fetchPosCreditDetail(Order_num) {
  const token = localStorage.getItem('token');
  return (dispatch) => {
    dispatch(requestPosCreditDetail());
    return axios.get(
      `${POS_CREDIT_URL}${Order_num}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    )
      .then((response) => {
        dispatch(fetchPosCreditDetailSuccess(response));
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        dispatch(fetchPosCreditDetailFailure(err));
      });
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/pos_actions.jsx